<template>
    <div>
        <div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
            <el-card class="box-card">
                <el-row style="margin-bottom: 20px">
                    <el-col :span="24">
                        <div style="line-height: 3rem; font-size: 1.5rem;">线上大队考核管理</div>
                    </el-col>
                </el-row>
                <el-row style="margin-bottom: 20px">
                    <el-col :span="4">
                        <el-select @change="changeIndex" clearable :disabled="deptdisable"   filterable    v-model="searchBmid" placeholder="请选择大队">
                            <el-option
                                    v-for="item in depts"
                                    :key="item.BMID"
                                    :label="item.BMMC"
                                    :value="item.BMID"
                                    :disabled="deptdisable">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-date-picker
                            v-model="searchYear"
                            type="year"
                            placeholder="选择年份"
                            value-format="yyyy"
                            :clearable="false">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="4">
                        <el-select v-model="searchJd" clearable placeholder="请选择">
                            <el-option
                                v-for="item in jdOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="loadData">查询</el-button>
                    </el-col>
                    <el-col :span="2">
                       <el-button type="success" @click="exportExcel">导出Excel</el-button>
                    </el-col>
                    <!-- <el-col :span="3">
                       <el-button type="primary" @click="addXxkh">线下填报</el-button>
                    </el-col> -->
                </el-row>
                <el-tabs v-model="tabsName" @tab-click="handleClick" stretch="true" >
                    <el-tab-pane label="巡逻覆盖率" name="xlfgl">
                        <div>
                            <el-table
                                :data="xlfglData"
                                style="width: 100%"
                                v-loading="xlfglTableLoading">
                                <el-table-column
                                    prop="bmmc"
                                    label="大队">
                                </el-table-column>
                                <el-table-column
                                    prop="gdzs"
                                    label="岗点总数">
                                </el-table-column>
                                <el-table-column
                                    prop="xlgds"
                                    label="巡逻岗点数">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="clickXlgds(scope.row)">{{scope.row.xlgds}}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="xlfgl"
                                    label="巡逻覆盖率">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.xlfgl">{{scope.row.xlfgl}}%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="zf"
                                    label="总分">
                                </el-table-column>
                                <el-table-column
                                    prop="df"
                                    label="得分">
                                </el-table-column>
                                <el-table-column
                                    prop="time"
                                    label="月份">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                @size-change="xlfglHandleSizeChange"
                                @current-change="xlfglHandleCurrentChange"
                                :current-page="xlfglCurrentNo"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="xlfglPageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="xlfglPageTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="巡逻执行率" name="xlzxl">
                        <div>
                            <el-table
                                :data="xlzxlData"
                                style="width: 100%"
                                v-loading="xlzxlTableLoading">
                                <el-table-column
                                    prop="bmmc"
                                    label="大队"
                                    width="180">
                                </el-table-column>
                                <el-table-column
                                    prop="xlgds"
                                    label="巡逻岗点数">
                                </el-table-column>
                                <el-table-column
                                    prop="xldws"
                                    label="巡逻点位数">
                                </el-table-column>
                                <el-table-column
                                    prop="dyts"
                                    label="当月天数">
                                </el-table-column>
                                <el-table-column
                                    prop="yxls"
                                    label="应巡逻数">
                                </el-table-column>
                                <el-table-column
                                    prop="xljls"
                                    label="巡逻记录数">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="clickXljls(scope.row)">{{scope.row.xljls}}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="xlzxl"
                                    label="巡逻执行率">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.xlzxl">{{scope.row.xlzxl}}%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="zf"
                                    label="总分">
                                </el-table-column>
                                <el-table-column
                                    prop="df"
                                    label="得分">
                                </el-table-column>
                                <el-table-column
                                    prop="pjf"
                                    label="平均分">
                                </el-table-column>
                                <el-table-column
                                    prop="time"
                                    label="月份">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                @size-change="xlzxlHandleSizeChange"
                                @current-change="xlzxlHandleCurrentChange"
                                :current-page="xlzxlCurrentNo"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="xlzxlPageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="xlzxlPageTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="大队长约谈率" name="ddzytl">
                        <div>
                            <el-table
                                :data="ddzytlData"
                                style="width: 100%"
                                v-loading="ddzytlTableLoading">
                                <el-table-column
                                    prop="xm"
                                    label="姓名"
                                    width="180">
                                </el-table-column>
                                <el-table-column
                                    prop="gw"
                                    label="职位">
                                </el-table-column>
                                <el-table-column
                                    prop="bmmc"
                                    label="大队">
                                </el-table-column>
                                <el-table-column
                                    prop="ddrs"
                                    label="大队人数">
                                </el-table-column>
                                <el-table-column
                                    prop="ytjls"
                                    label="约谈记录数">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="clickDdzYtjls(scope.row)">{{scope.row.ytjls}}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="ytl"
                                    label="约谈率">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.ytl">{{scope.row.ytl}}%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="zf"
                                    label="总分">
                                </el-table-column>
                                <el-table-column
                                    prop="df"
                                    label="得分">
                                </el-table-column>
                                <el-table-column
                                    prop="month"
                                    label="月份">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                @size-change="ddzytlHandleSizeChange"
                                @current-change="ddzytlHandleCurrentChange"
                                :current-page="ddzytlCurrentNo"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="ddzytlPageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="ddzytlPageTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane> -->
                    <el-tab-pane label="大队约谈率" name="ddytl">
                        <div>
                            <el-table
                                :data="ddytlData"
                                style="width: 100%"
                                v-loading="ddytlTableLoading">
                                <el-table-column
                                    prop="bmmc"
                                    label="大队">
                                </el-table-column>
                                <el-table-column
                                    prop="ddrs"
                                    label="大队人数">
                                </el-table-column>
                                <el-table-column
                                    prop="ytjls"
                                    label="大队约谈记录数">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="clickDdYtjls(scope.row)">{{scope.row.ytjls}}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="ytl"
                                    label="大队约谈率">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.ytl">{{scope.row.ytl}}%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="xm"
                                    label="大队长姓名">
                                </el-table-column>
                                <el-table-column
                                    prop="ddzytjls"
                                    label="大队长约谈数">
                                </el-table-column>
                                <el-table-column
                                    prop="ddzytl"
                                    label="大队长约谈率">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.ytl">{{scope.row.ddzytl}}%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="zf"
                                    label="总分">
                                </el-table-column>
                                <el-table-column
                                    prop="df"
                                    label="最终得分">
                                </el-table-column>
                                <el-table-column
                                    prop="jd"
                                    label="季度">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                @size-change="ddytlHandleSizeChange"
                                @current-change="ddytlHandleCurrentChange"
                                :current-page="ddytlCurrentNo"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="ddytlPageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="ddytlPageTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="队伍考勤合格率" name="dwkqhgl">
                        <div>
                            <el-table
                                :data="dwkqhglData"
                                style="width: 100%"
                                v-loading="dwkqhglTableLoading">
                                <el-table-column
                                    prop="bmmc"
                                    label="大队"
                                    width="180">
                                </el-table-column>
                                <el-table-column
                                    prop="pbzs"
                                    label="排班总数">
                                </el-table-column>
                                <el-table-column
                                    prop="cdcs"
                                    label="迟到">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="clickCdcs(scope.row)">{{scope.row.cdcs}}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="ztcs"
                                    label="早退">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="clickZtcs(scope.row)">{{scope.row.ztcs}}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="kgcs"
                                    label="旷工">
                                    <template slot-scope="scope">
                                        <el-link type="primary" @click="clickKgcs(scope.row)">{{scope.row.kgcs}}</el-link>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="kqhgl"
                                    label="考勤合格率">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.kqhgl">{{scope.row.kqhgl}}%</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="zf"
                                    label="总分">
                                </el-table-column>
                                <el-table-column
                                    prop="df"
                                    label="得分">
                                </el-table-column>
                                <el-table-column
                                    prop="pjf"
                                    label="月平均分">
                                </el-table-column>
                                <el-table-column
                                    prop="month"
                                    label="月份">
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                @size-change="dwkqhglHandleSizeChange"
                                @current-change="dwkqhglHandleCurrentChange"
                                :current-page="dwkqhglCurrentNo"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="dwkqhglPageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="dwkqhglPageTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="基层管理行动轨迹" name="jcglxdgj">基层管理行动轨迹</el-tab-pane> -->
                    <!-- <el-tab-pane label="访客登记推广率" name="fkdjtgl">访客登记推广率</el-tab-pane>
                    <el-tab-pane label="问卷调查回访率" name="wjdchfl">问卷调查回访率</el-tab-pane> -->
                </el-tabs>
            </el-card>

            <!-- 巡逻覆盖率-巡逻岗点数 -->
            <xlfglxq-xlgds-dialogvisible v-if="xlfglXqByXlgdsDialogVisible" ref="xlgds"></xlfglxq-xlgds-dialogvisible>
            <!-- 巡逻执行率-巡逻记录数 -->
            <xlzxlxq-xljls-dialogvisible v-if="xlzxlXqByXljlsDialogVisible" ref="xljls"></xlzxlxq-xljls-dialogvisible>
            <!-- 大队长约谈率-约谈记录数 -->
            <ddzytlxq-ytjls-dialogvisible v-if="ddzytlXqByYtjlsDialogVisible" ref="ddzytjls"></ddzytlxq-ytjls-dialogvisible>
            <!-- 大队约谈率-约谈记录数 -->
            <ddytlxq-ytjls-dialogvisible v-if="ddytlXqByYtjlsDialogVisible" ref="ddytjls"></ddytlxq-ytjls-dialogvisible>
            <!-- 队伍考勤合格率-迟到/早退/旷工 -->
            <dwkqhgl-all-dialogvisible v-if="dwkqhglXqDialogVisible" ref="dwkqhglxq"></dwkqhgl-all-dialogvisible>
            
            <el-dialog
                title="线下填报内容(50分)"
                :visible.sync="xxkkVisible"
                width="50%"
                :before-close="handleClose">
                <div class="container">
                    <div class="addButton">
                        <el-button style=" padding: 3px 0" type="text" @click="addXxkhtable">新增</el-button>
                    </div>
                    <div class="tabsDiv">
                        <el-tabs type="border-card" stretch="true" class="elTabls" @tab-click="xxhandleClick">
                            <el-tab-pane label="个税申报(5分)">
                                <el-table
                                    :data="gssbData"
                                    style="width: 100%"
                                    v-loading="ddytlTableLoading">
                                    <el-table-column
                                        prop="bbsj"
                                        label="申报时间">
                                    </el-table-column>
                                    <el-table-column
                                        prop="sffb"
                                        label="是否发布">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.sffb == 0" style="color: red; font-weight: bold;">未发布</span>
                                            <span v-if="scope.row.sffb == 1" style="color: green; font-weight: bold;">已发布</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        label="操作"
                                        width="120">
                                        <template slot-scope="scope">
                                            <el-button
                                             @click="getThisInfo(scope.row.bbsj)"
                                            type="text"
                                            v-if="scope.row.sffb == 1"
                                            size="small">
                                            查看
                                            </el-button>
                                            <el-button
                                            v-if="scope.row.sffb == 0"
                                            @click="editThisInfo(scope.row.bbsj)"
                                            type="text"
                                            size="small">
                                            编辑
                                            </el-button>
                                            <el-button
                                            v-if="scope.row.sffb == 0"
                                            @click="release(scope.row.bbsj)"
                                            type="text"
                                            size="small">
                                            发布
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                    @size-change="gssbHandleSizeChange"
                                    @current-change="gssbHandleCurrentChange"
                                    :current-page="gssbCurrentNo"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="gssbPageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="gssbPageTotal">
                                </el-pagination>
                            </el-tab-pane>
                            <el-tab-pane label="服装回收(5分)">
                                <el-table
                                    :data="fzhsData"
                                    style="width: 100%"
                                    v-loading="ddytlTableLoading">
                                    <el-table-column
                                        prop="bbsj"
                                        label="申报时间">
                                    </el-table-column>
                                    <el-table-column
                                        prop="sffb"
                                        label="是否发布">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.sffb == 0" style="color: red; font-weight: bold;">未发布</span>
                                            <span v-if="scope.row.sffb == 1" style="color: green; font-weight: bold;">已发布</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        label="操作"
                                        width="120">
                                        <template slot-scope="scope">
                                            <el-button
                                             @click="getThisInfo(scope.row.bbsj)"
                                            type="text"
                                            v-if="scope.row.sffb == 1"
                                            size="small">
                                            查看
                                            </el-button>
                                            <el-button
                                            v-if="scope.row.sffb == 0"
                                            @click="editThisInfo(scope.row.bbsj)"
                                            type="text"
                                            size="small">
                                            编辑
                                            </el-button>
                                            <el-button
                                            v-if="scope.row.sffb == 0"
                                            @click="fzhsRelease(scope.row.bbsj)"
                                            type="text"
                                            size="small">
                                            发布
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                    @size-change="fzhsHandleSizeChange"
                                    @current-change="fzhsHandleCurrentChange"
                                    :current-page="fzhsCurrentNo"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="fzhsPageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="fzhsPageTotal">
                                </el-pagination>
                            </el-tab-pane>
                            <el-tab-pane label="保安勤务(30分)">
                                <el-table
                                    :data="gaqwData"
                                    style="width: 100%"
                                    v-loading="ddytlTableLoading">
                                    <el-table-column
                                        prop="bbsj"
                                        label="申报时间">
                                    </el-table-column>
                                    <el-table-column
                                        prop="sffb"
                                        label="是否发布">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.sffb == 0" style="color: red; font-weight: bold;">未发布</span>
                                            <span v-if="scope.row.sffb == 1" style="color: green; font-weight: bold;">已发布</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        fixed="right"
                                        label="操作"
                                        width="120">
                                        <template slot-scope="scope">
                                            <el-button
                                             @click="getThisInfo(scope.row.bbsj)"
                                            type="text"
                                            v-if="scope.row.sffb == 1"
                                            size="small">
                                            查看
                                            </el-button>
                                            <el-button
                                            v-if="scope.row.sffb == 0"
                                            @click="editThisInfo(scope.row.bbsj)"
                                            type="text"
                                            size="small">
                                            编辑
                                            </el-button>
                                            <el-button
                                            v-if="scope.row.sffb == 0"
                                            @click="baqwRelease(scope.row.bbsj)"
                                            type="text"
                                            size="small">
                                            发布
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <!-- <el-pagination
                                    @size-change="baqwHandleSizeChange"
                                    @current-change="baqwHandleCurrentChange"
                                    :current-page="baqwCurrentNo"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="baqwPageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="baqwsPageTotal"> -->
                                </el-pagination>
                            </el-tab-pane>
                            <el-tab-pane label="情况上报(10分)">情况上报</el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </el-dialog>
          
        </div>
    </div> 
</template>
<script>
  import XlfglxqXlgdsDialogvisible from './common/xlfglxq-xlgds-dialogvisible.vue';
  import XlzxlxqXljlsDialogvisible from './common/xlzxlxq-xljls-dialogvisible.vue';
  import DdzytlxqYtjlsDialogvisible from './common/ddzytlxq-ytjls-dialogvisible.vue';
  import DdytlxqYtjlsDialogvisible from './common/ddytlxq-ytjls-dialogvisible.vue';
  import DwkqhglAllDialogvisible from './common/dwkqhgl-all-dialogvisible.vue';
  import exportToExcel from '@/utils/exportToExcel'
  export default {
    components: { XlfglxqXlgdsDialogvisible, XlzxlxqXljlsDialogvisible, DdzytlxqYtjlsDialogvisible,
         DdytlxqYtjlsDialogvisible, DwkqhglAllDialogvisible},
    data() {
      return {
        onTabName:'',
        //巡逻覆盖率
        xlfglHeader:['大队','岗点总数','巡逻岗点数','巡逻覆盖率','总分','得分','月份'],
        xlfglKey:['bmmc','gdzs','xlgds','xlfgl','zf','df','time'],
        //巡逻执行率
        xlzxlHeader:['大队','巡逻岗点数','巡逻点位数','当月天数','应巡逻数','巡逻记录数','巡逻执行率','总分','得分','月份'],
        xlzxlKey:['bmmc','xlgds','xldws','dyts','yxls','xljls','xlzxl','zf','df','time'],
        //大队长约谈率
        ddzytlHeader:['姓名','职位','大队','大队人数','约谈记录数','约谈率','总分','得分','月份'],
        ddzytlKey:['xm','gw','bmmc','ddrs','ytjls','ytl','zf','df','month'],
        //大队约谈率
        ddytlHeader:['大队','大队人数','约谈记录数','约谈率','总分','得分','月份'],
        ddytlKey:['bmmc','ddrs','ytjls','ytl','zf','df','month'],
        //队伍考勤合格率
        dwkqhglHeader:['大队','排班总数','迟到','早退','旷工','考勤合格率','总分','得分','月份'],
        dwkqhglKey:['bmmc','pbzs','cdcs','ztcs','kgcs','kqhgl','zf','df','month'],
        tabsName: 'xlfgl',
        searchBmid: '',
        searchYear: '',
        searchJd: '',
        deptdisable: false,
        xxkkVisible: false,
        gssbVisible: false,
        gssbInfoVisible: false,
        depts: [],
        gaqwData: [],
        gssbData: [],
        fzhsData: [],
        baqwData: [],
        jdOptions:  [{
                    value: '1',
                    label: '一月'
                    }, {
                    value: '2',
                    label: '二月'
                    }, {
                    value: '3',
                    label: '三月'
                    }, {
                    value: '4',
                    label: '四月'
                    }, {
                    value: '5',
                    label: '五月'
                    }, {
                    value: '6',
                    label: '六月'
                    }, {
                    value: '7',
                    label: '七月'
                    }, {
                    value: '8',
                    label: '八月'
                    }, {
                    value: '9',
                    label: '九月'
                    }, {
                    value: '10',
                    label: '十月'
                    }, {
                    value: '11',
                    label: '十一月'
                    }, {
                    value: '12',
                    label: '十二月'
                    }
        ],
        jdParams: '',
        xlfglCurrentNo: 1,
        xlfglPageSize: 10,
        xlfglPageTotal: 0,
        tab: {},
        xlfglXqByXlgdsDialogVisible: false,
        xlfglTableLoading: false,
        xlfglData: [],  //巡逻覆盖率
        xlzxlCurrentNo: 1,
        xlzxlPageSize: 10,
        xlzxlPageTotal: 0,
        xlzxlXqByXljlsDialogVisible: false,
        xlzxlTableLoading: false,
        xlzxlData: [],  //巡逻执行率
        ddzytlCurrentNo: 1,
        ddzytlPageSize: 10,
        ddzytlPageTotal: 0,
        ddzytlXqByYtjlsDialogVisible: false,
        ddzytlTableLoading: false,
        ddzytlData:[],  //大队长约谈率
        ddytlCurrentNo: 1,
        ddytlPageSize: 10,
        ddytlPageTotal: 0,
        ddytlXqByYtjlsDialogVisible: false,
        ddytlTableLoading: false,
        ddytlData:[],  //大队约谈率
        dwkqhglCurrentNo: 1,
        dwkqhglPageSize: 10,
        dwkqhglPageTotal: 0,
        dwkqhglXqDialogVisible: false,
        dwkqhglTableLoading: false,
        dwkqhglData:[] , //队伍考勤合格率
        gssbPageSize:10,
        gssbPageTotal: 0,
        gssbCurrentNo: 1,

        fzhsPageSize:10,
        fzhsPageTotal: 0,
        fzhsCurrentNo: 1,

        baqwPageSize:10,
        baqwPageTotal: 0,
        baqwCurrentNo: 1,
        baqwsPageTotal: 0,
        tabsIndex: 0
      }
    },
    created(){
        this.searchYear = this.$moment().format('YYYY')
        this.loadData()
        // this.getDdytl()
        this.getDepts()
        this.onTabName = tab.name;
    },
    methods: {
        loadData() {
            if (this.searchJd) {
                if (this.searchJd == '1' ) {
                    this.jdParams = "'" + this.searchYear + "-01'" 
                }
                if (this.searchJd == '2' ) {
                    this.jdParams = "'" + this.searchYear + "-02'" 
                }
                if (this.searchJd == '3' ) {
                    this.jdParams = "'" + this.searchYear + "-03'" 
                }
                if (this.searchJd == '4' ) {
                    this.jdParams = "'" + this.searchYear + "-04'" 
                }
                if (this.searchJd == '5' ) {
                    this.jdParams = "'" + this.searchYear + "-05'" 
                }
                if (this.searchJd == '6' ) {
                    this.jdParams = "'" + this.searchYear + "-06'" 
                }
                if (this.searchJd == '7' ) {
                    this.jdParams = "'" + this.searchYear + "-07'" 
                }
                if (this.searchJd == '8' ) {
                    this.jdParams = "'" + this.searchYear + "-08'" 
                }
                if (this.searchJd == '9' ) {
                    this.jdParams = "'" + this.searchYear + "-09'" 
                }
                if (this.searchJd == '10' ) {
                    this.jdParams = "'" + this.searchYear + "-10'" 
                }
                if (this.searchJd == '11' ) {
                    this.jdParams = "'" + this.searchYear + "-11'" 
                }
                if (this.searchJd == '12' ) {
                    this.jdParams = "'" + this.searchYear + "-12'" 
                }
                
            } else {
                this.jdParams = ''
            }
            console.log('this.onTabName==',this.onTabName)
            if(this.onTabName == 'xlfgl'){
                this.getXlfgl()
            }else if (this.onTabName == 'xlzxl'){
                this.getXlzxl()
            }else if (this.onTabName == 'ddytl'){
                this.getDdytl()
            }else if (this.onTabName == 'dwkqhgl'){
                this.getDwKqhgl()
            }else{
                this.getXlfgl()
                this.getXlzxl()
                this.getDdytl()
                this.getDwKqhgl()
            }  
        },
        changeIndex() {
            this.xlfglCurrentNo = 1
            this.xlzxlCurrentNo = 1
            this.ddzytlCurrentNo = 1
            this.ddytlCurrentNo = 1
            this.dwkqhglCurrentNo = 1
        },
        handleClick(tab, event) {
            this.onTabName = tab.name
            console.log('tab===',this.onTabName)
            
            if(this.onTabName == 'ddzytl' || this.onTabName == 'ddytl'){
            
                this.jdOptions = [{
                    value: '1',
                    label: '第一季度'
                    }, {
                    value: '2',
                    label: '第二季度'
                    }, {
                    value: '3',
                    label: '第三季度'
                    }, {
                    value: '4',
                    label: '第四季度'
                }]
            }else{
                this.jdOptions = [{
                    value: '1',
                    label: '一月'
                    }, {
                    value: '2',
                    label: '二月'
                    }, {
                    value: '3',
                    label: '三月'
                    }, {
                    value: '4',
                    label: '四月'
                    }, {
                    value: '5',
                    label: '五月'
                    }, {
                    value: '6',
                    label: '六月'
                    }, {
                    value: '7',
                    label: '七月'
                    }, {
                    value: '8',
                    label: '八月'
                    }, {
                    value: '9',
                    label: '九月'
                    }, {
                    value: '10',
                    label: '十月'
                    }, {
                    value: '11',
                    label: '十一月'
                    }, {
                    value: '12',
                    label: '十二月'
                    }
                ]
            }
        },
        indexMethod(index) {
            return index + 1;
        },
        getDepts() {
            // let that = this;
            // this.$request.get('/bjba/kqtj/getFirstMentForUser',{
            //     params: {
            //         userid:this.$store.getters.username
            //     }
            // }).then(res => {
            //     that.depts = res.data
            //     if(this.depts && this.depts[0]) {

            //         var zzdyqc = this.$store.getters.user.zzdyqc;
            //         if(zzdyqc){
            //             if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
            //                 var zw = this.$store.getters.user.zw;

            //                 if(zw) {
            //                     if(zw=='01'||zw=='02'||zw=='03') {
            //                         this.bmid = that.depts[0].bmid
            //                         this.deptdisable = true

            //                     }

            //                 }
            //             }

            //         }

            //     }
            // })
            this.$request({
				method: 'get',
				url: '/bjba/khxx/xjxx/findDdData'
			}).then((response)=>{
                if(response.data.code === 200){
                   this.depts = response.data.data 
                }
			}).catch((err)=>{
				console.log(err)
			});
        },
        xlfglHandleSizeChange(val) {
            this.xlfglPageSize = val;
            this.getXlfgl();
        },
        xlfglHandleCurrentChange(val) {
            this.xlfglCurrentNo = val;
            this.getXlfgl();
        },
        //个税上报分页
        gssbHandleSizeChange(val){
            this.gssbPageSize = val;
            this.getGssbs();
        },
        gssbHandleCurrentChange(val) {
            this.gssbCurrentNo = val;
            this.getGssbs();
        },
         // 个税上报分页结束
         //服装回收分页
         fzhsHandleSizeChange(val){
            this.fzhsPageSize = val;
            this.getFzhs();
        },
        fzhsHandleCurrentChange(val) {
            this.fzhsCurrentNo = val;
            this.getFzhs();
        },
        // 服装回收结束

        //保安勤务分页
        baqwHandleSizeChange(val){
            this.baqwPageSize = val;
            // this.getBaqw();
        },
        fzhsHandleCurrentChange(val) {
            this.baqwCurrentNo = val;
            // this.getBaqw();
        },
        // 保安勤务结束
        getXlfgl() {
            this.xlfglTableLoading = true
            this.$request({
                url: '/bjba/ddkhgl/getXlfgl',
                method: 'get',
                params: {
                    page: this.xlfglCurrentNo,
                    pagesize: this.xlfglPageSize,
                    year: this.searchYear,
                    jd: this.jdParams,
                    bmid: this.searchBmid
                }
            }).then(res => {
                this.xlfglTableLoading = false
                console.log("获取到的巡逻覆盖率数据为：",res)
                this.xlfglData = res.data.data.content
                this.xlfglPageTotal = res.data.data.totalElements
            }).catch(err => {
                this.xlfglTableLoading = false
                console.log(err)
            })
        },
        clickXlgds(val) {
            console.log("点击巡逻岗点数：",val)
            if (val.xlgds === '0') {
                this.$message({
                    message: '不存在巡逻岗点数据',
                    type: 'error'
                });
            } else {
                this.xlfglXqByXlgdsDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.xlgds.init(val)
                }) 
            }
        },
        xlzxlHandleSizeChange(val) {
            this.xlzxlPageSize = val;
            this.getXlzxl();
        },
        xlzxlHandleCurrentChange(val) {
            this.xlzxlCurrentNo = val;
            this.getXlzxl();
        },
        getXlzxl() {
            this.xlzxlTableLoading = true
            this.$request({
                url: '/bjba/ddkhgl/getXlzxl',
                method: 'get',
                params: {
                    page: this.xlzxlCurrentNo,
                    pagesize: this.xlzxlPageSize,
                    year: this.searchYear,
                    jd: this.jdParams,
                    bmid: this.searchBmid
                }
            }).then(res => {
                this.xlzxlTableLoading = false
                console.log("获取到的巡逻执行率数据为：",res)
                this.xlzxlData = res.data.data.content
                this.xlzxlPageTotal = res.data.data.totalElements
            }).catch(err => {
                this.xlzxlTableLoading = false
                console.log(err)
            })
        },
      
        clickXljls(val) {
            console.log("点击巡逻记录数：",val)
            if (val.xljls === '0') {
                this.$message({
                    message: '不存在巡逻记录数据',
                    type: 'error'
                });
            } else {
                this.xlzxlXqByXljlsDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.xljls.init(val)
                }) 
            }
        },
        ddzytlHandleSizeChange(val) {
            this.ddzytlPageSize = val;
            this.getDdzytl();
        },
        ddzytlHandleCurrentChange(val) {
            this.ddzytlCurrentNo = val;
            this.getDdzytl();
        },
        getDdzytl() {
            // this.ddzytlTableLoading = true
            // this.$request({
            //     url: '/bjba/ddkhgl/getDdzytl',
            //     method: 'get',
            //     params: {
            //         page: this.ddzytlCurrentNo,
            //         pagesize: this.ddzytlPageSize,
            //         year: this.searchYear,
            //         jd: this.jdParams,
            //         bmid: this.searchBmid
            //     }
            // }).then(res => {
            //     this.ddzytlTableLoading = false
            //     console.log("获取到的大队长约谈率数据为：",res)
            //     this.ddzytlData = res.data.data.content
            //     this.ddzytlPageTotal = res.data.data.totalElements
            // }).catch(err => {
            //     this.ddzytlTableLoading = false
            //     console.log(err)
            // })
        },
        clickDdzYtjls(val) {
            console.log("点击约谈记录数：",val)
            if (val.ytjls === '0') {
                this.$message({
                    message: '不存在约谈记录数据',
                    type: 'error'
                });
            } else {
                this.ddzytlXqByYtjlsDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.ddzytjls.init(val)
                }) 
            }
        },        
        ddytlHandleSizeChange(val) {
            this.ddytlPageSize = val;
            this.getDdytl();
        },
        ddytlHandleCurrentChange(val) {
            this.ddytlCurrentNo = val;
            this.getDdytl();
        },
        getDdytl() {
            this.ddytlTableLoading = true
            this.$request({
                url: '/bjba/ddkhgl/getDdytl',
                method: 'get',
                params: {
                    page: this.ddytlCurrentNo,
                    pagesize: this.ddytlPageSize,
                    year: this.searchYear,
                    jd: this.searchJd,
                    bmid: this.searchBmid
                }
            }).then(res => {
                this.ddytlTableLoading = false
                console.log("获取到的大队约谈率数据为：",res)
                this.ddytlData = res.data.data.content
                this.ddytlPageTotal = res.data.data.totalElements
            }).catch(err => {
                this.ddytlTableLoading = false
                console.log(err)
            })
        },
        clickDdYtjls(val) {
            console.log("点击约谈记录数：",val)
            if (val.ytjls === '0') {
                this.$message({
                    message: '不存在约谈记录数据',
                    type: 'error'
                });
            } else {
                this.ddytlXqByYtjlsDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.ddytjls.init(val)
                }) 
            }
        },
        dwkqhglHandleSizeChange(val) {
            this.dwkqhglPageSize = val;
            this.getDwKqhgl();
        },
        dwkqhglHandleCurrentChange(val) {
            this.dwkqhglCurrentNo = val;
            this.getDwKqhgl();
        },
        getDwKqhgl() {
            this.dwkqhglTableLoading = true
            this.$request({
                url: '/bjba/ddkhgl/getDwKqhgl',
                method: 'get',
                params: {
                    page: this.dwkqhglCurrentNo,
                    pagesize: this.dwkqhglPageSize,
                    year: this.searchYear,
                    jd: this.jdParams,
                    bmid: this.searchBmid
                }
            }).then(res => {
                this.dwkqhglTableLoading = false
                console.log("获取到的队伍考勤合格率数据为：",res)
                this.dwkqhglData = res.data.data.content
                this.dwkqhglPageTotal = res.data.data.totalElements
            }).catch(err => {
                this.dwkqhglTableLoading = false
                console.log(err)
            })
        },
        clickCdcs(val) {
            console.log("点击迟到次数：",val)
            if (val.cdcs === '0') {
                this.$message({
                    message: '不存在迟到数据',
                    type: 'error'
                });
            } else {
                this.dwkqhglXqDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.dwkqhglxq.init(val,1)
                }) 
            }
        },
        clickZtcs(val) {
            console.log("点击早退次数：",val)
            if (val.ztcs === '0') {
                this.$message({
                    message: '不存在早退数据',
                    type: 'error'
                });
            } else {
                this.dwkqhglXqDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.dwkqhglxq.init(val,2)
                }) 
            }
        },
        clickKgcs(val) {
            console.log("点击旷工次数：",val)
            if (val.kgcs === '0') {
                this.$message({
                    message: '不存在旷工数据',
                    type: 'error'
                });
            } else {
                this.dwkqhglXqDialogVisible = true
                this.$nextTick(() => {
                    this.$refs.dwkqhglxq.init(val,3)
                }) 
            }
        },
        /**
         * 导出excel
         */
         exportExcel(){
            const name = this.onTabName
            
            //巡逻覆盖率
            if(name == 'xlfgl'){
                const params = {
                    // 对应的表头
                    header: this.xlfglHeader,
                    // 对应的字段
                    key: this.xlfglKey,
                    // 选择的数据，数组类型
                    data: this.xlfglData,
                    // // 自动调整宽度
                    autoWidth: true,
                    // 导出的文件名
                    fileName: '巡逻覆盖率',
                    // 导出的文件类型，xlsx,csv,txt
                    bookType: 'xlsx'
                }
                exportToExcel.exportDataToExcel(params)
            }
             //巡逻覆盖率
            if(name == 'xlzxl'){
                const params = {
                    // 对应的表头
                    header: this.xlzxlHeader,
                    // 对应的字段
                    key: this.xlzxlKey,
                    // 选择的数据，数组类型
                    data: this.xlzxlData,
                    // // 自动调整宽度
                    autoWidth: true,
                    // 导出的文件名
                    fileName: '巡逻执行率',
                    // 导出的文件类型，xlsx,csv,txt
                    bookType: 'xlsx'
                }
                exportToExcel.exportDataToExcel(params)
            }
             //大队长约谈率
            if(name == 'ddzytl'){
                const params = {
                    // 对应的表头
                    header: this.ddzytlHeader,
                    // 对应的字段
                    key: this.ddzytlKey,
                    // 选择的数据，数组类型
                    data: this.ddzytlData,
                    // // 自动调整宽度
                    autoWidth: true,
                    // 导出的文件名
                    fileName: '大队长约谈率',
                    // 导出的文件类型，xlsx,csv,txt
                    bookType: 'xlsx'
                }
                exportToExcel.exportDataToExcel(params)
            }
             //大队约谈率
            if(name == 'ddytl'){
                const params = {
                    // 对应的表头
                    header: this.ddytlHeader,
                    // 对应的字段
                    key: this.ddytlKey,
                    // 选择的数据，数组类型
                    data: this.ddytlData,
                    // // 自动调整宽度
                    autoWidth: true,
                    // 导出的文件名
                    fileName: '大队约谈率',
                    // 导出的文件类型，xlsx,csv,txt
                    bookType: 'xlsx'
                }
                exportToExcel.exportDataToExcel(params)
            }
            //队伍考勤合格率
            if(name == 'dwkqhgl'){
                const params = {
                    // 对应的表头
                    header: this.dwkqhglHeader,
                    // 对应的字段
                    key: this.dwkqhglKey,
                    // 选择的数据，数组类型
                    data: this.dwkqhglData,
                    // // 自动调整宽度
                    autoWidth: true,
                    // 导出的文件名
                    fileName: '队伍考勤合格率',
                    // 导出的文件类型，xlsx,csv,txt
                    bookType: 'xlsx'
                }
                exportToExcel.exportDataToExcel(params)
            }
            
        },
        //新增线下考核
        addXxkh() {
            console.log('线下考核')
            this.xxkkVisible = true
            this.getGssbs()
            this.getFzhs()
        },
        //关闭窗口
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        },
        // showDialog() {
        //     this.dialogVisible = true;
        // },
        //打开个税申报页面
        openGssb(){
            const routeData = this.$router.resolve({
                name: 'gssb'
            });
            window.open(routeData.href, '_blank');
            // const interval = setInterval(() => {
            //     if (newWindow.closed) {
            //         clearInterval(interval);
            //         // 新窗口关闭后的逻辑，例如刷新数据
            //         this.onNewWindowClose();
            //     }
            // }, 500);
        },
        // onNewWindowClose() {
        //     // 新窗口关闭后的逻辑
        //     console.log('新窗口已关闭');
        //     // 可以在这里添加刷新数据的逻辑
        //     this.getGssbs()
        //     this.getFzhs()
        // },
        
        //打开服装回收页面
        openFzhs(){
            const routeData = this.$router.resolve({
                name: 'fzhs'
            });
            window.open(routeData.href, '_blank');
        },
        //打开保安勤务页面
        openBaqw(){
            const routeData = this.$router.resolve({
                name: 'baqw'
            });
            window.open(routeData.href, '_blank');
        },
        //打开情况上报页面
        openQksb(){
            const routeData = this.$router.resolve({
                name: 'qksb'
            });
            window.open(routeData.href, '_blank');
        },
        //tabs 点击事件
        xxhandleClick(tab, event) {
            this.tabsIndex = tab.index
        },

        addXxkhtable(){
            console.log('index=',this.tabsIndex)
            if (this.tabsIndex == 0) {
                this.openGssb()   
            } else if(this.tabsIndex == 1) {
                this.openFzhs() 
            } else if(this.tabsIndex == 2) {
                this.openBaqw()
            }else{
                console.log('情况上报')
            }
        },
        //查看 详情
        getThisInfo(val){
            if (this.tabsIndex == 0) {
                this.getGssbInfo(val)   
            } else if(this.tabsIndex == 1) {
                this.getFzhsInfo(val)
            } else if(this.tabsIndex == 2) {
                console.log('保安勤务')
            }else{
                console.log('情况上报')
            }
        },
        //编辑 详情
        editThisInfo(val){
            if (this.tabsIndex == 0) {
                this.eidtGssbInfo(val)   
            } else if(this.tabsIndex == 1) {
                this.eidtFzhsInfo(val) 
            } else if(this.tabsIndex == 2) {
                console.log('保安勤务')
            }else{
                console.log('情况上报')
            }
        },

       //个税申报===================================================================
        getGssbs(){
            console.log('获取申报列表')
            this.$request({
                url: '/bjba/khxx/gssb/getGssbs',
                method: 'get',
                params: {
                    page: this.dwkqhglCurrentNo,
                    pagesize: this.dwkqhglPageSize
                }
            }).then(res => {
                this.gssbData = res.data.data.content
                this.gssbPageTotal = res.data.data.totalElements
            }).catch(err => {
                console.log(err)
            })
        },
        //获取详情
        getGssbInfo(val){
            console.log('sbsj =',val)
            const routeData = this.$router.resolve({
                name: 'gssbInfo',
                params: { sbsj: val}
            });
            console.log('url==',routeData.href)
            window.open(routeData.href, '_blank');
        },
         //编辑详情
         eidtGssbInfo(val){
            console.log('sbsj =',val)
            const routeData = this.$router.resolve({
                name: 'gssbedit',
                params: { sbsj: val}
            });
            console.log('url==',routeData.href)
            window.open(routeData.href, '_blank');
            // const interval = setInterval(() => {
            //     if (newWindow.closed) {
            //         clearInterval(interval);
            //         // 新窗口关闭后的逻辑，例如刷新数据
            //         this.onNewWindowClose();
            //     }
            // }, 500);
        },
         // 发布
        release(val) {
            this.$confirm('确认发布？发布后不可更改')
            .then(_ => {
                this.$request.get('/bjba/khxx/gssb/release',{
                    params: {bbsj:val}
                }).then(res => {
                    if(res.data.code === 200){

                        this.$message({
                                message: res.data.message,
                                type: 'success',
                                duration: 1500
                            })
                        this.$router.go(0);
                    }else {
                        this.$message({
                                message: res.data.message,
                                type: 'error',
                                duration: 1500
                            })
                    }
                })
            })
            .catch(_ => {});

        },


        //服装回收==========================================================================

        //获取个税列表
        getFzhs(){
            this.$request({
                url: '/bjba/khxx/fzhs/getFzhs',
                method: 'get',
                params: {
                    page: this.dwkqhglCurrentNo,
                    pagesize: this.dwkqhglPageSize
                }
            }).then(res => {
                this.fzhsData = res.data.data.content
                this.fzhsPageTotal = res.data.data.totalElements
            }).catch(err => {
                console.log(err)
            })
        },
        //获取详情
        getFzhsInfo(val){
            console.log('sbsj =',val)
            const routeData = this.$router.resolve({
                name: 'fzhsInfo',
                params: { sbsj: val}
            });
            console.log('url==2222======',routeData.href)
            window.open(routeData.href, '_blank');
        },
         //编辑详情
         eidtFzhsInfo(val){
            console.log('sbsj =',val)
            const routeData = this.$router.resolve({
                name: 'fzhsedit',
                params: { sbsj: val}
            });
            console.log('url==',routeData.href)
            window.open(routeData.href, '_blank');
            // const interval = setInterval(() => {
            //     if (newWindow.closed) {
            //         clearInterval(interval);
            //         // 新窗口关闭后的逻辑，例如刷新数据
            //         this.onNewWindowClose();
            //     }
            // }, 500);
        },
         // 发布
        fzhsRelease(val) {
            console.log('发布')
            this.$confirm('确认发布？发布后不可更改')
            .then(_ => {
                this.$request.get('/bjba/khxx/fzhs/release',{
                    params: {bbsj:val}
                }).then(res => {
                    if(res.data.code === 200){

                        this.$message({
                                message: res.data.message,
                                type: 'success',
                                duration: 1500
                            })
                        this.$router.go(0);
                    }else {
                        this.$message({
                                message: res.data.message,
                                type: 'error',
                                duration: 1500
                            })
                    }
                })
            })
            .catch(_ => {});

        },
        // 勤务======================================================================================
    }
  };
</script>
<style scoped>
.container {
  /* display: flex; */
  /* position: relative; */
  position: relative;
  /* padding-top: 45px; */
}
.elTabls {
 width: 100%;
}
.leftDiv {
  flex: 1;
}
 
.rightDiv {
    flex: 1;
}
.addButton{
    position: absolute;
    z-index: 1;
    top: -30px;
    right: 50px;
}
.tabsDiv{

    margin-top: 10px;
}
</style>
